import { GetRequestOptions } from "./grunt";

const getDokumentTipPth = process.env.REACT_APP_GRUNT_API + "/migracija/migracijatip/dokumenttip";
const getDolazakAdd = process.env.REACT_APP_GRUNT_API + "/migracija/dolazak";
const getDolazakScan = process.env.REACT_APP_GRUNT_API + "/migracija/dolazak/scan";
const getOdlazakAdd = process.env.REACT_APP_GRUNT_API + "/migracija/odlazak";
const getDolazakDel = process.env.REACT_APP_GRUNT_API + "/migracija/dolazak";
const getOdlazakDel = process.env.REACT_APP_GRUNT_API + "/migracija/odlazak";
const getDolasciPth = process.env.REACT_APP_GRUNT_API + "/migracija/dolazak/all";
const getOdlasciPth = process.env.REACT_APP_GRUNT_API + "/migracija/odlazak/all";
const getDolasciFilterPth = process.env.REACT_APP_GRUNT_API + "/migracija/dolazak/filter/dolazak";
const getOdlasciFilterPth = process.env.REACT_APP_GRUNT_API + "/migracija/odlazak/filter/odlazak";
const getDolazakByMigracijaIdPth = process.env.REACT_APP_GRUNT_API + "/migracija/dolazak";
const getOdlazakByMigracijaIdPth = process.env.REACT_APP_GRUNT_API + "/migracija/odlazak";
const getDolazakStatistikaPth = process.env.REACT_APP_GRUNT_API + "/migracija/dolazak/statistika";
const getIzlucenjeVerificiranPth = process.env.REACT_APP_GRUNT_API + "/migracija/odlazak/izlucenje/verificiraj";
const StatusOk = { status: 200 };
const getDokumentTip = async () => {
    //let _pth=getOsobePth+`/${orderbycolumn}/${orderby}/${offset}/${limit}`;
    try {
        const r = await fetch(getDokumentTipPth, GetRequestOptions("GET"));
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }

    } catch (ex) {
        return { code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name };
    }
}

const addDolazak = async ({ dokumenttipid, migracijatipsifra, knjigaid, datum, posjednikid, uktezina, ijr, dokumentbroj, goveda = [], govscansid = [],jibg="" }) => {
    try {

        let _reqopt = GetRequestOptions("POST");
        _reqopt.body = JSON.stringify({
            dokumenttipid: dokumenttipid, migracijatipsifra: migracijatipsifra, knjigaid: knjigaid, datum: datum,
            posjednikid: posjednikid, uktezina: uktezina,
            ijr: ijr, dokumentbroj: dokumentbroj, goveda: goveda, govscansid: govscansid,jibg:jibg
        });
        const r = await fetch(getDolazakAdd, _reqopt);
        const StatusOk = { status: 200 };
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod unosa migracije. " + error.message, status: error.status, name: error.name };
    }
}

const addOdlazak = async ({ dokumenttipid, migracijatipsifra, knjigaid, datum, migracijaposjednikid, migracijaknjigaid, uktezina, ijr, dokumentbroj, govedaid = [],jibg="" }) => {
    try {

        let _reqopt = GetRequestOptions("POST");
        _reqopt.body = JSON.stringify({
            dokumenttipid: dokumenttipid, migracijatipsifra: migracijatipsifra, knjigaid: knjigaid, datum: datum,
            migracijaposjednikid: migracijaposjednikid, migracijaknjigaid: migracijaknjigaid, uktezina: uktezina,
            ijr: ijr, dokumentbroj: dokumentbroj, govedaid: govedaid,jibg:jibg
        });
        const r = await fetch(getOdlazakAdd, _reqopt);
        const StatusOk = { status: 200 };
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod unosa migracije. " + error.message, status: error.status, name: error.name };
    }
}

const deleteDolazak = async ({ migracijaid }) => {
    try {
        const _pth = getDolazakDel + "/" + migracijaid;
        let _reqopt = GetRequestOptions("DELETE");

        const r = await fetch(_pth, _reqopt);
        const StatusOk = { status: 200 };
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod brisanja dolazne migracije. " + error.message, status: error.status, name: error.name };
    }
}

const deleteOdlazak = async ({ migracijaid }) => {
    try {
        const _pth = getOdlazakDel + "/" + migracijaid;
        let _reqopt = GetRequestOptions("DELETE");

        const r = await fetch(_pth, _reqopt);
        const StatusOk = { status: 200 };
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod brisanja odlazne migracije. " + error.message, status: error.status, name: error.name };
    }
}

const editDolazak = async ({ dmigracijaid = 0, dokumenttipid, migracijatipsifra, knjigaid, datum, posjednikid, uktezina, ijr, dokumentbroj, goveda = [],jibg="" }) => {
    try {

        let _reqopt = GetRequestOptions("PUT");
        _reqopt.body = JSON.stringify({
            dmigracijaid: dmigracijaid, dokumenttipid: dokumenttipid, migracijatipsifra: migracijatipsifra, knjigaid: knjigaid, datum: datum,
            posjednikid: posjednikid, uktezina: uktezina,
            ijr: ijr, dokumentbroj: dokumentbroj, goveda: goveda,jibg:jibg
        });
        const r = await fetch(getDolazakAdd, _reqopt);
        const StatusOk = { status: 200 };
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod ispravka dolaska. " + error.message, status: error.status, name: error.name };
    }
}


const editDolazakScan = async ({ dmigracijaid = 0, dokumenttipid, migracijatipsifra, knjigaid, datum, posjednikid, uktezina, ijr, dokumentbroj, govscansid = [] }) => {
    try {

        let _reqopt = GetRequestOptions("PUT");
        _reqopt.body = JSON.stringify({
            dmigracijaid: dmigracijaid, dokumenttipid: dokumenttipid, migracijatipsifra: migracijatipsifra, knjigaid: knjigaid, datum: datum,
            posjednikid: posjednikid, uktezina: uktezina,
            ijr: ijr, dokumentbroj: dokumentbroj, govscansid:govscansid
        });
        const r = await fetch(getDolazakScan, _reqopt);
        const StatusOk = { status: 200 };
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod ispravka migracije. " + error.message, status: error.status, name: error.name };
    }
}

const editOdlazak = async ({ omigracijaid = 0, dokumenttipid, knjigaid, datum, migracijaposjednikid, migracijaknjigaid, uktezina, ijr, dokumentbroj, govedaid = [], verificiran = true,jibg="" }) => {
    try {

        let _reqopt = GetRequestOptions("PUT");
        _reqopt.body = JSON.stringify({
            omigracijaid: omigracijaid, dokumenttipid: dokumenttipid, knjigaid: knjigaid, datum: datum,
            migracijaposjednikid: migracijaposjednikid, migracijaknjigaid: migracijaknjigaid, uktezina: uktezina,
            ijr: ijr, dokumentbroj: dokumentbroj, govedaid: govedaid, verificiran: verificiran,jibg:jibg
        });
        const r = await fetch(getOdlazakAdd, _reqopt);
        const StatusOk = { status: 200 };
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod unosa migracije. " + error.message, status: error.status, name: error.name };
    }
}

const editIzlucenjeVerifikacija = async (migracijaid = 0, verificiran = true) => {
    try {
        const _reqopt = GetRequestOptions("PUT");
        _reqopt.body = JSON.stringify({ migracijaid: migracijaid, verificiran: verificiran });
        const r = await fetch(getIzlucenjeVerificiranPth, _reqopt);
        const res = await r.json();
        const StatusOk = { status: 200 };
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }

    } catch (error) {
        return { code: error.code, message: "Greška kod izmjene izlučenja. " + error.message, status: error.status, name: error.name };
    }
}







const getDolazakByMigracijaId = async (migracijaid) => {
    let _reqopt = GetRequestOptions("GET");
    try {
        const r = await fetch(getDolazakByMigracijaIdPth + "/" + migracijaid, _reqopt);
        const StatusOk = { status: 200 };
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod čitanja podataka dolazaka. " + error.message, status: error.status, name: error.name };
    }
}

const getOdlazakByMigracijaId = async (migracijaid) => {
    let _reqopt = GetRequestOptions("GET");
    try {
        const r = await fetch(getOdlazakByMigracijaIdPth + "/" + migracijaid, _reqopt);
        const StatusOk = { status: 200 };
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod čitanja podataka dolazaka. " + error.message, status: error.status, name: error.name };
    }
}

const geStatistikaDolaska = async (migracijaid) => {
    let _reqopt = GetRequestOptions("GET");
    try {
        const r = await fetch(getDolazakStatistikaPth + "/" + migracijaid, _reqopt);
        const StatusOk = { status: 200 };
        const res = await r.json();
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod čitanja podataka statistike dolaska. " + error.message, status: error.status, name: error.name };
    }
}

const getDolasciFilter = async ({ datumod, datumdo, knjige = [], dolazaktipovi = [], odlazniposjednici = [], drzave = [],responsedatatype="app"  }) => {
    let _reqopt = GetRequestOptions("GET");

    let _qrystr = "?datumod=" + datumod + "&datumdo=" + datumdo;
    if (knjige.length > 0) {
        _qrystr = _qrystr + "&knjige=" + knjige.join("|");
    }
    if (dolazaktipovi.length > 0) {
        _qrystr = _qrystr + "&dolazaktipovi=" + dolazaktipovi.join("|");
    }
    if (odlazniposjednici.length > 0) {
        _qrystr = _qrystr + "&odlazniposjednici=" + odlazniposjednici.join("|");
    }
    if (drzave.length > 0) {
        _qrystr = _qrystr + "&drzave=" + drzave.join("|");
    }

    try {
        const r = await fetch(getDolasciFilterPth +"/"+responsedatatype+ _qrystr, _reqopt);
        const StatusOk = { status: 200 };
        let res;
        if (responsedatatype==='app') {
            res = await r.json();    
        } else {
            res=await r.arrayBuffer();
        }
        
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod čitanja podataka dolazaka. " + error.message, status: error.status, name: error.name };
    }
}
const getDolasci = async ({responsedatatype="app"}) => {
    let _reqopt = GetRequestOptions("GET");
    let _rtyp="/app";
    if (responsedatatype.toLowerCase()==="xlsx") {
        _rtyp='/xlsx';
    } else if (responsedatatype.toLowerCase()==="pdf") {
        _rtyp='/pdf';
    }
    try {
        const r = await fetch(getDolasciPth+_rtyp, _reqopt);
        const StatusOk = { status: 200 };
        let res;
        if (responsedatatype==='app') {
            res = await r.json();    
        } else {
            res=await r.arrayBuffer();
        }
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod čitanja podataka dolazaka. " + error.message, status: error.status, name: error.name };
    }
}
const getOdlasci = async ({_verificiran = true,responsedatatype="app"}) => {
    let _reqopt = GetRequestOptions("GET");
    let _rtyp="/app";
    if (responsedatatype.toLowerCase()==="xlsx") {
        _rtyp='/xlsx';
    } else if (responsedatatype.toLowerCase()==="pdf") {
        _rtyp='/pdf';
    }
    try {
        const r = await fetch(getOdlasciPth + "/" + _verificiran+_rtyp, _reqopt);
        const StatusOk = { status: 200 };
        let res;
        if (responsedatatype==='app') {
            res = await r.json();    
        } else {
            res=await r.arrayBuffer();
        }
        
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod čitanja podataka dolazaka. " + error.message, status: error.status, name: error.name };
    }
}
const getOdlasciFilter = async ({ datumod, datumdo, knjige = [], odlazaktipovi = [], noviposjednici = [], noveknjige = [], klaonice = [], drzave = [], verificiran = true,responsedatatype="app" }) => {
    let _reqopt = GetRequestOptions("GET");

    let _qrystr = "?datumod=" + datumod + "&datumdo=" + datumdo;
    if (knjige.length > 0) {
        _qrystr = _qrystr + "&knjige=" + knjige.join("|");
    }
    if (odlazaktipovi.length > 0) {
        _qrystr = _qrystr + "&odlazaktipovi=" + odlazaktipovi.join("|");
    }
    if (noviposjednici.length > 0) {
        _qrystr = _qrystr + "&posjednici=" + noviposjednici.join("|");
    }
    if (drzave.length > 0) {
        _qrystr = _qrystr + "&drzave=" + drzave.join("|");
    }
    if (noveknjige.length > 0) {
        _qrystr = _qrystr + "&noveknjige=" + noveknjige.join("|");
    }
    if (klaonice.length > 0) {
        _qrystr = _qrystr + "&klaonice=" + klaonice.join("|");
    }
    _qrystr = _qrystr + "&verificiran=" + verificiran.toString();
    try {
        const r = await fetch(getOdlasciFilterPth+"/"+responsedatatype + _qrystr, _reqopt);
        const StatusOk = { status: 200 };
        //const res = await r.json();
        let res;
        if (responsedatatype==='app') {
            res = await r.json();    
        } else {
            res=await r.arrayBuffer();
        }
        if (r.status === 200) {
            StatusOk.res = res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (error) {
        return { code: error.code, message: "Greška kod čitanja podataka odlazaka. " + error.message, status: error.status, name: error.name };
    }
}


export {
    getDokumentTip, addDolazak, addOdlazak, editDolazak, editOdlazak, getDolasci, getOdlasci, getDolasciFilter, getOdlasciFilter, getDolazakByMigracijaId,
    getOdlazakByMigracijaId, deleteDolazak, deleteOdlazak, geStatistikaDolaska, editIzlucenjeVerifikacija, editDolazakScan
};